import { render, staticRenderFns } from "./external-login-callback.vue?vue&type=template&id=629607a6"
import script from "./external-login-callback.vue?vue&type=script&lang=js"
export * from "./external-login-callback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('629607a6')) {
      api.createRecord('629607a6', component.options)
    } else {
      api.reload('629607a6', component.options)
    }
    module.hot.accept("./external-login-callback.vue?vue&type=template&id=629607a6", function () {
      api.rerender('629607a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/account/external-login-callback.vue"
export default component.exports